(function () {
    'use strict';

    angular
        .module('app.widgets')
        .directive('obtOnlineReceptionist', obtOnlineReceptionist);

    function obtOnlineReceptionist () {
        return {
            restrict: 'E',
            template:"<span ng-if=\'phoneNumber\' ng-switch=\'isOnline || \"false\"\'>    \n    <button ng-switch-when=\'true\' class=\'btn btn-xs btn-success-advisor\'>\n        {{ phoneNumber }} <img  ng-src=\'img/headset.svg\' width=\'18px\'  height=\'18px\' alt=\'headset\' /> {{ \'ONLINE\'|translate }}\n    </button>\n    <span ng-switch-default>{{phoneNumber}}</span>\n</span>",
            scope: {
                phoneNumber: '@',
                isOnline: '@?'
            }
        };
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-online-receptionist.directive.js
 ** module id = 193
 ** module chunks = 0
 **/